module.exports = __webpack_public_path__ + "img/logo.d5e786a7.png";